import axios from "axios"
import router from "../router/index"
import store from '../store'
import i18n from '../i18n'
import { ToastProgrammatic as Toast } from 'buefy'

const ApiService = {
    farmadomiciliosApiURL: '',
    farmadomiciliosApiURLapigateway: '',

    init(baseURL) {
        axios.defaults.baseURL = baseURL
    },

    getHostAndPort() {
        const baseUrl = axios.defaults.baseURL.split('://')
        return baseUrl.length === 1 ? baseUrl[0] : baseUrl[1]
    },

    setHeader(header, value) {
        axios.defaults.headers.common[header] = value
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) {
        return axios.get(resource)
    },

    post(resource, data) {
        return axios.post(resource, data)
    },

    postFile(resource, file) {
        const formData = new FormData()
        const headers = { 'Content-Type': 'multipart/form-data' }
        formData.append("attachment", file)
        return axios.post(resource, formData, { headers })
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    patch(resource, data) {
        return axios.patch(resource, data)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return axios(data)
    }
}

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        let message = null
        let response = error.response

        if (response) {
            if (response.status === 401) {
                message = i18n.t('app.session-finished')
                store.dispatch("auth/logout").then(() => {
                    router.push("/login")
                })
            }
        }

        if (message) {
            Toast.open({ message, type: 'is-danger' })
        }

        return Promise.reject(response ? response.data : error)
    }
)

export default ApiService